/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Nutrition_Of_YieldInputs */

const en_nutrition_of_yield = /** @type {(inputs: Nutrition_Of_YieldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`recipe makes ${i?.count}`)
};

const de_nutrition_of_yield = /** @type {(inputs: Nutrition_Of_YieldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rezept ergibt ${i?.count}`)
};

/**
* | output |
* | --- |
* | "recipe makes {count}" |
*
* @param {Nutrition_Of_YieldInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const nutrition_of_yield = /** @type {((inputs: Nutrition_Of_YieldInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nutrition_Of_YieldInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nutrition_of_yield(inputs)
	return en_nutrition_of_yield(inputs)
});